// extracted by mini-css-extract-plugin
export default {"section":"section_3jkHI","edit":"edit_3g_Gk","edit-input":"edit-input_287nG"};